// TODO: this is not exhaustive
export const StarsSchedulingStatuses = [
  'Passed (CR)',
  'Passed',
  'Passed/Not Sched',
  'Compensated',
  'Not Passed/Sched',
  'Not Passed/Not Sched',
];
